import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { CATEGORY_BY_ID, ACCENT_CLASSES } from "@/data/ai-lab/categories";
import { OUTPUT_TYPE_ICON } from "./CategoryIcon";

const OUTPUT_LABEL = { text: "Text prompt", image: "Image prompt", video: "Video prompt", audio: "Audio prompt" };

/** TaskCard — links to the Prompt Builder for one task. */
export default function TaskCard({ task, showCategory = false, className }) {
  const cat = CATEGORY_BY_ID[task.category];
  const OutIcon = OUTPUT_TYPE_ICON[task.outputType] || OUTPUT_TYPE_ICON.text;
  return (
    <Link to={`/ai-cpg-tools/prompt-builder/${task.id}`} className="group block h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl">
      <Card className={cn("h-full transition-colors group-hover:border-foreground/30", className)}>
        <CardContent className="flex h-full flex-col gap-2 p-4">
          <div className="flex items-center gap-2">
            {showCategory && cat && <Badge className={cn("border-transparent font-medium", ACCENT_CLASSES[cat.accent]?.badge)} variant="outline">{cat.short}</Badge>}
            <Badge variant="outline" className="gap-1 font-normal text-muted-foreground"><OutIcon className="h-3 w-3" />{OUTPUT_LABEL[task.outputType]}</Badge>
          </div>
          <h3 className="text-base font-semibold leading-snug">{task.title}</h3>
          <p className="line-clamp-2 text-sm text-muted-foreground">{task.description}</p>
          <div className="mt-auto flex items-center justify-between pt-2 text-xs text-muted-foreground">
            <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" />{task.estimatedTime}</span>
            <span className="inline-flex items-center gap-1 font-medium text-foreground">Build <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" /></span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
